import axios from 'axios'

export default {
    namespaced: true,

    actions: {
        onWorkClientProjectsPeriodReportUpdate({commit, rootState}, {id, data, paid, extra, responsible}) {
            commit('setLoadingAnimationFullPage', true, {root: true})
            return new Promise((resolve, reject) => {
                let employee_reports = {}
                let work_extras = {}
                if (extra) work_extras.work_extras = data
                else employee_reports.employee_reports = data
                axios({
                    url: rootState.apiDomain
                      + '/api/admin/work/client/project/period-report/employee/'
                      + (extra ? 'extra/' : '')
                      + (responsible ? 'responsible-approved/' : paid ? 'paid/' : 'approved/'),
                    data: extra ? work_extras : employee_reports,
                    method: 'PUT',
                })
                    .then((resp) => {
                        commit('setLoadingAnimationFullPage', false, {root: true})
                        resolve(resp)
                    })
                    .catch((err) => {
                        commit('setLoadingAnimationFullPage', false, {root: true})
                        reject(err)
                    })
            })
        }
    }
}
